import { jsx as _jsx } from "react/jsx-runtime";
import { ManagedModalLifecycleContext } from '#pplx/frontend/aether/components/Modal/context/ManagedModalLifecycleContext.js';
import { useManagedModalLifecycle } from '#pplx/frontend/aether/modals/internal/useManagedModalLifecycle.js';
import { InstrumentationInheritedScope } from '#pplx/frontend/framework/instrumentation/InstrumentationInheritedScope.js';
import { memo, Suspense } from 'react';
/**
 * Wraps the rendered modal in `<InstrumentationInheritedScope>` so the modal
 * subtree resolves under the caller's instrumentation chain (captured at
 * `useModalContext` call time and stored on `modalState.inheritScope`).
 *
 * The wrap unconditionally replaces the renderer's tree position with the
 * caller's chain — including when `inheritScope` is `null` or `undefined`,
 * which severs the renderer-position chain to `null` rather than passing
 * through. In practice that's the desired contract: `useModalContext`
 * always determines the modal's parent chain, never the renderer's tree
 * position (which is typically `<GlobalModalRenderer>` at the app shell
 * and would otherwise leak shell-level scope into modals).
 */
export const ModalStateRenderer = memo(function ModalStateRenderer({ modalState }) {
    const lifecycleContext = useManagedModalLifecycle(modalState);
    return (_jsx(Suspense, { children: _jsx(ManagedModalLifecycleContext.Provider, { value: lifecycleContext, children: _jsx(InstrumentationInheritedScope, { parent: modalState.inheritScope ?? null, children: _jsx(modalState.modal, { ...modalState.props }) }) }) }));
});
//# sourceMappingURL=ModalStateRenderer.js.map